<template>
  <DefaultLayout>
    <ErrorCommon :error="props.error" />
  </DefaultLayout>
</template>

<script setup lang="ts">
  const DefaultLayout = defineAsyncComponent(() => import('./layouts/default.vue'));
  const ErrorCommon = defineAsyncComponent(() => import('~/components/ErrorCommon.vue'));

  const props = defineProps<{ error: unknown }>();

  provide('eventCategory', () => '404');

  console.error(props.error?.statusCode, 'error-page', props.error?.message, props.error?.url);
</script>
